module.exports = __webpack_public_path__ + "img/title-bg.f5e9a3fd.png";